import { createAsyncThunk } from '@reduxjs/toolkit';

import { LoansService } from 'api';
import { DownloadLoanAgreementProps } from 'models/api';

import { downloadDocuments } from 'utils';

export const getPrimaryMarketItemAgreement = createAsyncThunk(
	'primaryMarket/getPrimaryMarketItemAgreement',
	(data: DownloadLoanAgreementProps) =>
		downloadDocuments(data, `Loan agreement #${data.id}.pdf`, LoansService.getAgreement),
);
